export default __webpack_public_path__ + "static/media/AO-6.da8eb487.jpg";